export default "__VITE_ASSET__Deb$FNA0__"